import type { MatchmakingV2HostCapacityConfigPayload } from '@playcastdotio/Messaging';
import { applyRemoteMaxPlayers } from '../../../coordinators/game-instance/hostCapacityConfig';

/**
 * Android multi-instance (host Phase 6, G3): consume the API's
 * `MATCHMAKING_V2_HOST_CAPACITY_CONFIG` push and apply it to the host
 * capacity config.
 *
 * One file, one message. The production wiring lives in the matchmakingV2
 * namespace dispatcher (`handlers/matchmakingV2.ts`), which routes the parsed
 * payload here.
 *
 * Ack convention: the v2 contract has no ack envelope for API→host pushes, so
 * application is confirmed implicitly — `applyRemoteMaxPlayers` emits the
 * capacity store change, `GameLaunchCoordinator` listens on that store and
 * re-sizes + flushes a fresh `MATCHMAKING_V2_HOST_STATE_REPORT` whose
 * `machine.maxPlayers` reflects the new value. That report is the ack the
 * API's desired-state reconciliation waits for. We log for diagnostics.
 */
export const createCapacityConfigHandler = (
  apply: (maxPlayers: number) => void,
) => {
  return (payload: MatchmakingV2HostCapacityConfigPayload): void => {
    console.log('[CapacityConfig-Handler] Applying API capacity push:', {
      maxPlayers: payload.maxPlayers,
    });
    apply(payload.maxPlayers);
  };
};

/** Production binding: applies the push through the host capacity config store. */
export const handleCapacityConfigMessage = createCapacityConfigHandler(applyRemoteMaxPlayers);
